import { BaseEitherError } from '@uniqkey-frontend/shared-app';
import { SupportJumpMissingStoreDataError } from '../../common/errors';

export class SupportJumpFailedToEncryptPayloadError extends BaseEitherError {}

export type TSupportJumpCreateTrustedActionPayloadOperationErrors =
  SupportJumpMissingStoreDataError
  | SupportJumpFailedToEncryptPayloadError;
